module.exports = __webpack_public_path__ + "fonts/fontello.ac296a3.ttf";